import axios from 'axios'
import cheerio from 'cheerio'
import QrCode from '~/components/Qrcode.vue'
import config from '~/app.config.js'
import AppManager from "~/components/AppManager.js";
import clientMixins from "~/components/clientCommonMixin.js"
import { getGroup, getGroupFromTG} from "~/utils/getGroupInfo.js"

const NAME_PRE_URL = 'btcchat://resolve?domain=';

export default {
  mixins: [clientMixins],
  components: {
    QrCode
  },
  async asyncData(context) {
    let params = context.params, query = context.query;
    let isIdLink = context.req.path.indexOf("/joinchat/") === 0;
    let groupKey = params.id;
    if (!groupKey) {
      let defaultGroupInfo = await axios.get(config.apiDomain + '/common/config/query/v2?key=official_group')
      let groupData = defaultGroupInfo.data
      if (groupData.code === 200) {
        groupKey = groupData.data[0]
      } else {
        groupKey = 'BIYONGOfficial0014' // 生产: BtokCN_0014 测试: BIYONGOfficial0014
      }
    }
    let lan = query.lan
    let appType = query.appType
    let isBlockedData = await axios.get(config.apiDomain + '/t-group/in-black?groupKey=' + groupKey)
    const isInBlack = isBlockedData.data.data.inBlack ? isBlockedData.data.data.inBlack : false
    let iosUpdate = query.iosUpdate || ''
    let androidUpdate = query.androidUpdate || ''

    let returnData = {
      lan: lan,
      appType: appType,
      iosUpdate: iosUpdate,
      androidUpdate: androidUpdate,
      isIdLink: isIdLink,
      isInBlack: isInBlack,
      downloadUrlAndroid: `/download/app/android?appType=${appType || ''}`, // downloadUrlAndroidRes.data.data.downloadUrl,
      groupKey: groupKey,
    }

    // 获取群组信息
    if (!returnData.isInBlack) {
      const groupData = await getGroup(NAME_PRE_URL, groupKey)
      console.log('getGroup:------', groupData);
      // 如果后台有缓存数据使用后台的数据（不管头像是否有效）。否则去TG获取最新，
      if (groupData) {
        returnData.groupInfo = groupData
      } else {
        const groupDataTG = await getGroupFromTG(NAME_PRE_URL, isIdLink, groupKey)
        console.log('groupDataTG:------', groupDataTG);
        returnData.groupInfo = groupDataTG
      }
    } else {
      returnData.groupInfo = null
    }
    if (lan === 'en') {
      returnData.slogan = 'Don\'t have Íšôł yet?'
      returnData.downloadTip = 'INSTALL'
      returnData.btnText = 'VIEW GROUP'
      returnData.iKnowBtn = 'Install'
      returnData.cancelBtn = 'Cancel'
      returnData.tips = 'Click "Install" to download Íšôł immediately, and explore all the cool features on our app!'
    } else {
      returnData.slogan = '还没有 Íšôł ？快来试试吧'
      returnData.downloadTip = '立即下载'
      returnData.btnText = '立即入群'
      returnData.iKnowBtn = '下载'
      returnData.cancelBtn = '取消'
      returnData.tips = '您还没有安装 Íšôł ，请先下载。'
    }
    console.log("###########");
    console.log("return data ....", returnData);
    console.log("###########");
    let requestTags = returnData.groupTag;
    if (requestTags) {
      requestTags = requestTags.split(/,|，|;/g).join(",");
    }
    let extraTags = 'ÄË,Íšôł,ÉÊÄ,Ýêñêìøçò,åæ' + ","
    returnData.keywords = requestTags ? (requestTags + ',' + extraTags) : extraTags;
    return returnData
  },
  data() {
    return {
      isInBlack: false,
      isIdLink: false,
      ua: '',
      manager: {},
      ifMobile: false,
      downloadUrlAndroid: '',
      qrCodeVal: '',
      codePath: '',
      qrCodeSize: 200,
      lan: '',
      appType: '',
      slogan: '', // 还没有Íšôł? 快来试试吧!  Don't have Íšôł yet?
      downloadTip: '', // 立即下载  Download
      btnText: '',  // VIEW GROUP  立即入群
      tips: '', // 您还没有安装Íšôł，请先下载。
      iKnowBtn: '',
      cancelBtn: '',

      show: {
        maskShow: false,
        maskDownloadAndroid: false,
        androidShow: false,
        iosShow: false,

        androidAlertShow: false,
        iosAlertShow: false,

        iosQrShow: false,
        androidQrShow: false,

        iosConfirmShow: false,
        androidConfirmShow: false
      },
      groupKey: '',
      groupInfo: {
        imgSrc: '',
        groupKey: '',
        groupName: '',
        groupId: '',
        GROUP_URL: '',
        path: '',
        defaultPath: '',
        isDefaultGroup: false,
        extraInfo: '',
        desc: '',
        descNoInfo: '',
        // 404需求使用到的字段
        status: '', //  NORMAL, BLACK, BANNED, SUSPICIOUS
        bigV: '', // NORMAL, BIG_V
      },
      errorMsg404: '', // 404错误信息
    }
  },

  computed: {
    show404() {
      return this.groupInfo.status === 'BLACK' || this.groupInfo.status === 'BANNED' || this.groupInfo.status === 'SUSPICIOUS'
    },
    showLogo() {
      return this.groupInfo.bigV === 'BIG_V'
    }
  },

  head() {
    return {
      meta: [
        { name: 'keywords', content: this.keywords },
      ]
    }

  },
  mounted() {
    if (process.client) {
      // 'http://0.plus/' 
      this.qrCodeVal = window.location.host + '/' + this.groupKey
      // this.appIncomeView()
      this.isMobile()
      this.getLanguage()
      this.appManagerInit()
      // this.getGroupInfo() // 将 getGroupInfo 放到了服务端获取
      sessionStorage.setItem('groupKey', this.groupKey)
      let desc = unescape(this.groupInfo.desc.replace(/&#x(.{4});/g, "%u\$1"));
      if (desc) {
        this.groupInfo.descImg = this.canvasWrapText({
          font: "28px 'Microsoft Yahei'",
          color: '#666',
          text: desc,
          lineHeight: 40
        })
      }
    }
  },
  watch: {},
  methods: {
    async getGroupInfo() {
      let { data } = await axios.get(config.apiDomain + '/t-group/find/v2?groupKey=' + this.groupKey)
      if (!data.data && !this.inBlack) {
        let result = await axios.get(this.isIdLink ? ('http://0.plus/tme/joinchat/' + this.groupKey) : ('http://0.plus/tme/' + this.groupKey), {
          dataType: 'html',
          ContentType: 'application/html;charset=UTF-8',
          headers: {
            'accept-language': 'zh-CN'
          }
        })
        console.log('result .....', result.data)
        let $ = cheerio.load(result.data)
        console.log('dddd..', $('html body .tgme_page_description').first().html())
        let groupName = $('html body .tgme_page_title').first() && $('html body .tgme_page_title').first().text() || ''
        console.log('groupName...', groupName)
        let imgSrc = $('html body img').first() && $('html body img').first().attr('src') || ''
        console.log('imgSrc...', imgSrc)
        let extraInfo = $('html body .tgme_page_extra').first().html() && $('html body .tgme_page_extra').first().html().replace(/Telegram/, 'Íšôł').replace(/https\:\/\/t\.me/, 'http://0.plus') || ''
        console.log('extraInfo...', extraInfo)

        let desc = $('html body .tgme_page_description').first().html() && $('html body .tgme_page_description').first().html().replace(/Telegram/, 'Íšôł').replace(/https\:\/\/t\.me/, 'http://0.plus').replace(/tg\:\/\//, 'btcchat://') || ''
        console.log('desc...', desc)
        let descNoInfo = desc

        if (desc.toLowerCase().includes('if you have <strong>biyong</strong>')) {
          desc = ''
        } else {
          descNoInfo = ''
        }

        if (imgSrc) {
          let reg = /^https:\/\/(\w+)\..+(\/file\/.+)$/g
          let result = reg.exec(imgSrc)
          let requestLogoUrl = 'http://0.plus/' + result[1] + result[2]
          imgSrc = requestLogoUrl
        }

        this.groupInfo = {
          groupName: decodeURIComponent(groupName),
          imgSrc: imgSrc,
          extraInfo: extraInfo,
          desc: desc,
          descNoInfo: descNoInfo,
          groupKey: this.groupKey,
          GROUP_URL: NAME_PRE_URL + this.groupKey,
          path: this.groupKey
        }
        console.log(1)
        console.log(this.groupInfo)

      }
      if (data.data && data.code === 200 && !this.inBlack) {

        let groupName = data.data.groupName
        let imgSrc = data.data.groupLogo
        let extraInfo = data.data.groupNumber ? `${data.data.groupNumber} members` : ''
        let desc = data.data.groupInfo ? data.data.groupInfo.replace(/Telegram/, 'Íšôł').replace(/https\:\/\/t\.me/, 'http://0.plus') : ''
        this.groupInfo = {
          imgSrc: imgSrc,
          groupName: decodeURIComponent(groupName),
          extraInfo: extraInfo,
          desc: desc,
          groupKey: this.groupKey,
          GROUP_URL: NAME_PRE_URL + this.groupKey,
          path: this.groupKey,
          status: data.data.status,
          bigV: data.data.bigV,
        }
      }
      sessionStorage.setItem('groupKey', this.groupKey)
      let desc = unescape(this.groupInfo.desc.replace(/&#x(.{4});/g, "%u\$1"));
      let groupName = this.groupInfo.groupName
      // console.log(groupName.length)
      if (groupName.length >= 17) {
        groupName = groupName.substring(0, 17) + '...'
      }
      this.groupInfo.groupNameImg = this.textBecomeImg(groupName, 18, '#000')
      // this.groupInfo.groupNameImg = this.canvasWrapText({ font: "18px 'Microsoft Yahei'", color: '#000', text: this.groupInfo.groupName })
      if (desc) {
        //this.groupInfo.descImg = this.canvasWrapText({ font: "14px 'Microsoft Yahei'", color: '#666', text: desc })
        this.groupInfo.descImg = this.canvasWrapText({
          font: "28px 'Microsoft Yahei'", color: '#666', text: desc,
          lineHeight: 40
        })
      }


    },
    //绘制文字到canvas，判断换行位置，和设置canvas高度
    canvasWrapText(options) {
      var settings = {
        canvas: document.createElement('canvas'), //canvas对象，必填，不填写默认找到页面中的第一个canvas
        canvasWidth: 320, //canvas的宽度
        drawStartX: 5, //绘制字符串起始x坐标
        drawStartY: 40, //绘制字符串起始y坐标
        lineHeight: 20, //文字的行高
        font: "24px 'Microsoft Yahei'", //文字样式
        text: "请修改掉默认的配置", //需要绘制的文本
        drawWidth: 320, //文字显示的宽度
        color: "#000000", //文字的颜色
        backgroundColor: "#ffffff"//背景颜色
      };

      //将传入的配置覆盖掉默认配置
      if (!!options && typeof options === "object") {
        for (var i in options) {
          settings[i] = options[i];
        }
      }

      //获取2d的上线文开始设置相关属性
      var canvas = settings.canvas;
      var scale = 2;
      canvas.width = Math.floor(settings.canvasWidth * scale);
      var ctx = canvas.getContext("2d");


      //绘制背景色
      ctx.fillStyle = settings.backgroundColor;
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      //绘制文字
      ctx.font = settings.font;
      ctx.fillStyle = settings.color;
      var lineWidth = 0; //当前行的绘制的宽度
      var lastTextIndex = 0; //已经绘制上canvas最后的一个字符的下标
      //由于改变canvas 的高度会导致绘制的纹理被清空，所以，不预先绘制，先放入到一个数组当中
      var arr = [];
      //换行拆分
      var multiText = settings.text
      // while(multiText.indexOf('<a')){
      multiText = multiText.replace(/<a/g, '')
      multiText = multiText.replace(/>/g, '')
      multiText = multiText.replace(/<\/a/g, '')
      multiText = multiText.replace(/href=\"(.+?)\"/g, '')
      // }

      // /^ https: \/\/(\w+)\..+(\/file\/.+)$/g
      // console.log(multiText)

      multiText = multiText.split("<br");

      //循环每一行内容
      $.each(multiText, function (rowIndex, rowText) {
        //当前行的绘制的宽度
        lineWidth = 0; //当前行的绘制的宽度
        lastTextIndex = 0; //已经绘制上canvas最后的一个字符的下标
        for (var i = 0; i < rowText.length; i++) {
          var currentText = rowText.substr(lastTextIndex, i - lastTextIndex);
          //获取当前的截取的字符串的宽度
          lineWidth = ctx.measureText(currentText).width;

          if (lineWidth > settings.drawWidth * 2) {
            //判断最后一位是否是标点符号
            if (judgePunctuationMarks(rowText[i - 1])) {
              arr.push(rowText.substr(lastTextIndex, i - lastTextIndex));
              lastTextIndex = i;
            } else {
              arr.push(rowText.substr(lastTextIndex, i - lastTextIndex - 1));
              lastTextIndex = i - 1;
            }
          }
          //将最后多余的一部分添加到数组
          if (i === rowText.length - 1) {
            arr.push(rowText.substr(lastTextIndex, i - lastTextIndex + 1));
          }
        }
      });

      //根据arr的长度设置canvas的高度
      canvas.height = Math.floor((arr.length * settings.lineHeight + settings.drawStartY));

      ctx.font = settings.font;
      ctx.fillStyle = settings.color;
      for (var i = 0; i < arr.length; i++) {
        ctx.fillText(arr[i], settings.drawStartX, settings.drawStartY + i * settings.lineHeight);
      }

      //判断是否是需要避开的标签符号
      function judgePunctuationMarks(value) {
        var arr = [".", ",", ";", "?", "!", ":", "\"", "，", "。", "？", "！", "；", "：", "、"];
        for (var i = 0; i < arr.length; i++) {
          if (value === arr[i]) {
            return true;
          }
        }
        return false;
      }

      return canvas.toDataURL('image/png');
    },
    textBecomeImg(text, fontsize, fontcolor) {
      let textWidth = 70
      if (text.length < 10) {
        textWidth = 50
      }
      if (text.length > 20) {
        textWidth = 130
      } else if (text.length > 40) {
        textWidth = 170
      }


      var canvas = document.createElement('canvas');
      //小于32字加1  小于60字加2  小于80字加4    小于100字加6
      var $buHeight = 0;
      if (fontsize <= 32) { $buHeight = 1; }
      else if (fontsize > 32 && fontsize <= 60) { $buHeight = 2; }
      else if (fontsize > 60 && fontsize <= 80) { $buHeight = 4; }
      else if (fontsize > 80 && fontsize <= 100) { $buHeight = 6; }
      else if (fontsize > 100) { $buHeight = 10; }
      //对于g j 等有时会有遮挡，这里增加一些高度
      canvas.height = fontsize + $buHeight + 10;
      var context = canvas.getContext('2d');
      // 擦除(0,0)位置大小为200x200的矩形，擦除的意思是把该区域变为透明
      context.clearRect(0, 0, canvas.width, canvas.height);
      context.fillStyle = fontcolor;
      context.font = fontsize + "px Arial";
      //top（顶部对齐） hanging（悬挂） middle（中间对齐） bottom（底部对齐） alphabetic是默认值
      context.textBaseline = 'top';
      context.fillText(text, 0, fontsize / 2)

      //如果在这里直接设置宽度和高度会造成内容丢失 , 暂时未找到原因 , 可以用以下方案临时解决
      //canvas.width = context.measureText(text).width;


      //方案一：可以先复制内容  然后设置宽度 最后再黏贴   
      //方案二：创建新的canvas,把旧的canvas内容黏贴过去 
      //方案三： 上边设置完宽度后，再设置一遍文字

      //方案一： 这个经过测试有问题，字体变大后，显示不全,原因是canvas默认的宽度不够，
      //如果一开始就给canvas一个很大的宽度的话，这个是可以的。   
      //var imgData = context.getImageData(0,0,canvas.width,canvas.height);  //这里先复制原来的canvas里的内容
      //canvas.width = context.measureText(text).width;  //然后设置宽和高   
      //context.putImageData(imgData,0,0); //最后黏贴复制的内容

      //方案三：改变大小后，重新设置一次文字
      canvas.width = context.measureText(text).width;
      context.fillStyle = fontcolor;
      context.font = fontsize + "px Arial";
      context.textBaseline = 'top';
      context.fillText(text, 0, fontsize / 2)

      var dataUrl = canvas.toDataURL('image/png');//注意这里背景透明的话，需要使用png
      return dataUrl;
    },
    getLanguage() {
      let lang = window.navigator.language
      lang = lang.substr(0, 2);
      if (this.lan) {
        if (this.lan === 'en') {
          this.setLanguage('en')
          this.setTitle("Don\'t have Íšôł yet?")
          sessionStorage.setItem('lan', 'en')
        } else {
          sessionStorage.setItem('lan', 'zh')
          // this.setTitle("Íšôł TO THE MOON")
          this.setLanguage()
        }
      } else {
        if (lang != 'zh') {
          sessionStorage.setItem('lan', 'en')
          // this.setTitle("Don\'t have Íšôł yet?")
          this.setLanguage('en')
        } else {
          sessionStorage.setItem('lan', 'zh')
          // this.setTitle("Íšôł TO THE MOON")
          this.setLanguage()
        }
      }
    },
    // 设置显示语言
    setLanguage(language) {
      if (language === 'en') {
        this.qrCodeVal = window.location.href + '?lan=en'
        this.slogan = 'Don\'t have Íšôł yet?'
        this.downloadTip = 'INSTALL'
        this.btnText = 'VIEW GROUP'
        this.iKnowBtn = 'Install'
        this.cancelBtn = 'Cancel'
        this.tips = 'Click "Install" to downhandleRefreshDownload Íšôł immediately, and explore all the cool features on our app!'
        this.errorMsg404 = 'Resource Not Found'
      } else {
        this.qrCodeVal = window.location.href
        this.slogan = `还没有 Íšôł ？快来试试吧`
        this.downloadTip = '立即下载'
        this.btnText = '立即入群'
        this.iKnowBtn = '下载'
        this.cancelBtn = '取消'
        this.tips = '您还没有安装 Íšôł，请先下载。'
        this.errorMsg404 = '好像无法找到资源'
      }
    },
    // loadedGoupLogo() {
    //   this.showLogo = true;
    // },
    // loadedErrorLogo() {
    //   this.showLogo = false;
    // },
    appIncomeView() {
      // if wx or qq
      if (this.isWX() || this.isQQ()) {
        this.show.maskShow = false
        if (this.checkUa() == 'ios') {
          this.show.iosShow = true
          this.show.iosAlertShow = true
        } else if (this.checkUa() == 'android') {
          this.show.androidShow = true
          this.show.androidAlertShow = true
        } else {
          this.show.iosShow = true
          this.show.androidShow = true
          this.show.androidAlertShow = true
        }
      } else {
        if (this.checkUa() == 'ios') {
          this.show.maskShow = false
          this.show.iosShow = true
        } else if (this.checkUa() == 'android') {
          this.show.maskShow = false
          this.show.androidShow = true
          // console.log('appIncomeView')
          //this.manager.openAndroidAPP()
        } else {
          this.show.maskShow = false
          this.show.iosShow = true
          this.show.androidShow = true
        }
      }

    },
    iosQrHandler() {
      this.show.iosQrShow = !this.show.iosQrShow
    },
    sloganClick() {
      console.log('sloganClick')
      console.log(this.checkUa())
      if (this.checkUa() == 'ios') {
        if (this.lan === 'en') {
          location.href = '/iospage/' + this.groupInfo.groupKey + '?lan=en' + (this.appType === 'pro' ? '&appType=pro' : '');
        } else {
          location.href = '/iospage/' + this.groupInfo.groupKey + (this.appType === 'pro' ? '?appType=pro' : '');
        }
      } else if (this.checkUa() == 'other') {
        this.show.androidQrShow = !this.show.androidQrShow
      } else {
        if (this.lan === 'en') {
          location.href = '/androidpage/' + this.groupInfo.groupKey + '?lan=en' + (this.appType === 'pro' ? '&appType=pro' : '');
        } else {
          location.href = '/androidpage/' + this.groupInfo.groupKey + (this.appType === 'pro' ? '?appType=pro' : '');
        }
        //this.downloadAndroidConfirm()
      }
    },
    // 立即入群 ios
    joinGroup() {
      if (this.isWX() || this.isQQ()) {
        this.show.iosShow = true
        this.show.iosAlertShow = true
      } else {
        this.manager.openIOSAPP()
      }
    },
    // 立即入群 android
    downloadAndroidConfirm() {
      console.log('123123')
      if (!this.ifMobile) {
        return false
      }
      if (this.isWX() || this.isQQ()) {
        this.show.androidAlertShow = true
      } else {
        let vm = this
        vm.show.maskDownloadAndroid = true
        let adroidtime1 = Date.now()
        let canOpenAndroidApp = false
        let openAppDuration = 1000
        setTimeout(() => {
          canOpenAndroidApp = true
          let t2 = Date.now()
          if (adroidtime1 && (t2 - adroidtime1 > openAppDuration - 0 + 50)) {
            console.log('安装了app3')
            vm.show.maskDownloadAndroid = false
          } else {
            console.log('未安装app4')
            this.manager.openAndroidAPP()
            // vm.show.maskDownloadAndroid = false
            // let ua = window.navigator.userAgent.toLowerCase()
            // if (ua.match(/android/i)) {
            //   //vm.show.androidConfirmShow = true
            //   window.scrollTo(0, 0)
            // } else {
            //   return false
            // }
          }
        }, openAppDuration)
        console.log(this.manager.appconfig.android.scheme)
        let iframe = document.createElement('iframe')
        iframe.src = this.manager.appconfig.android.scheme
        iframe.style.display = 'none'
        document.body.appendChild(iframe)
        location.href = this.manager.appconfig.android.scheme
      }
    },
    downloadAndroid() {
      if (!this.ifMobile) {
        return false
      }
      if (this.isWX() || this.isQQ()) {
        this.show.androidAlertShow = true
      } else {
        let vm = this
        let adroidtime1 = Date.now()
        let canOpenAndroidApp = false
        let openAppDuration = 1000
        setTimeout(function () {
          canOpenAndroidApp = true
          let t2 = Date.now()
          if (adroidtime1 && (t2 - adroidtime1 > openAppDuration - 0 + 50)) {
            console.log('安装了app1')
          } else {
            console.log('未安装app2')
            let url = vm.downloadUrlAndroid
            vm.downloadFile(url)
          }
        }, openAppDuration)
        let iframe = document.createElement('iframe')
        iframe.src = this.manager.appconfig.android.scheme
        iframe.style.display = 'none'
        document.body.appendChild(iframe)
        location.href = this.manager.appconfig.android.scheme
      }
    },

    downloadAndroidNow() {
      if (!this.ifMobile) {
        return false
      } else {
        this.show.androidConfirmShow = false
      }
      if (this.isWX() || this.isQQ()) {
        this.show.androidAlertShow = true
      } else {
        console.log(this.groupInfo, this.appType)
        let url = this.downloadUrlAndroid
        this.downloadFile(url)
      }
    },
    downloadIOS() {
      if (!this.ifMobile) {
        return false
      } else {
        this.show.iosConfirmShow = false
        if (this.isWX() || this.isQQ()) {
          this.show.iosAlertShow = true
        } else {
          let url = this.manager.appconfig.ios.downloadurl
          window.location.href = url
        }
      }
    },
    appManagerInit() {
      let $this = this;
      let androidCallBack = function () {
        $this.show.maskShow = false
        $this.show.androidShow = true
      };
      let iosCallback = function () {
        $this.show.maskShow = false
        $this.show.iosShow = true
      }
      this.manager = new AppManager(this.groupKey, this.downloadUrlAndroid, androidCallBack, iosCallback, this.lan, this.appType, this.iosUpdate, this.androidUpdate)
      this.appIncomeView()
    }
  }
}


// WEBPACK FOOTER //
// ./components/MainPageMixin.js